import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "../../annotations";
import { CTA } from "./dtos";

const CALL_TO_ACTION_SERVICE = `${Constants.API_URL}/bedrock/call_to_actions`;

export type GetCallToActionsParams = {
  /** Single id, array of ids, or `null` for coach-level CTAs (nil player_id). */
  playerId?: number | null | Array<number | null>;
  distinct?: boolean;
};

export class CallToActionServices {
  @scCatchServiceException()
  static async getCallToActions({ playerId, distinct }: GetCallToActionsParams = {}): Promise<CTA[]> {
    const params: Record<string, unknown> = {};
    if (playerId !== undefined) {
      // "" keeps the query key so Rails can filter player_id IS NULL
      params.playerId = Array.isArray(playerId) ? playerId.map(id => id ?? "") : playerId ?? "";
    }
    if (distinct !== undefined) {
      params.distinct = distinct;
    }

    const { data } = await axios.get<CTA[]>(CALL_TO_ACTION_SERVICE, {
      params: Object.keys(params).length ? params : undefined,
    });
    return data;
  }
}
